<template>
  <div>
    <div v-if="hasMask" v-show="show" class="ssui-mask_transparent"></div>
    <transition name="ssui-fade">
      <div v-show="show" class="ssui-toast">{{text}}<slot></slot></div>
    </transition>
  </div>
</template>

<script>
import SafariFixIssue from '../../assets/js/safari-fix'

export default {
  mixins: [SafariFixIssue],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    hasMask: {
      type: Boolean,
      default: false
    },
    text: String
  },
  data () {
    return {
      show: false
    }
  },
  created () {
    if (this.value) {
      this.show = true
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.$emit('input', true)
        this.$emit('on-show')
        this.fixSafariOverflowScrolling('auto')

        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.show = false
          this.$emit('input', false)
          this.$emit('on-hide')
          this.fixSafariOverflowScrolling('touch')
        }, this.time)
      }
    },
    value (val) {
      this.show = val
    }
  }
}
</script>

<style lang="less">
@import '../../assets/less/transition.less';
</style>
